import { useMemo } from 'react';
import cn from 'classnames';

import useMartyContext from 'hooks/useMartyContext';
import MicrosoftAdsProduct from 'components/search/MicrosoftAdsProduct';
import { getLowStockLabelStatus } from 'helpers/cardUtils';
import MelodyCarousel from 'components/common/MelodyCarousel';

import css from 'styles/components/productdetail/microsoftAdsCarousel.scss';

const RECOS_TITLE = 'Discover More Items';

const MicrosoftAdsCarousel = ({
  CardBottomSlot,
  isFullMaxWidth,
  containerClassName,
  isHydraMobileTwoRecos,
  makeMicrosoftAdClick,
  msftResults = {},
  trackMicrosoftAdImpressions
}) => {
  const {
    marketplace: {
      search: { hasStyleRoomFlag, msaMelodyImageParams, hasMicrosoftAds }
    }
  } = useMartyContext();

  const products = useMemo(
    () =>
      msftResults.results?.map(product => ({
        ...product,
        isSponsored: true
      })),
    [msftResults.results]
  );

  if (!products || !hasMicrosoftAds || products.length === 0) {
    return null;
  }

  return (
    <div className={containerClassName}>
      <div
        className={cn(css.recoCarousel, {
          [css.fullMaxWidth]: isFullMaxWidth,
          [css.displayTwoCardTilesMobile]: isHydraMobileTwoRecos
        })}
      >
        <h2>{RECOS_TITLE}</h2>
        <MelodyCarousel showDots={false} isFullMaxWidth={isFullMaxWidth}>
          {products.map((product, i) => {
            const { styleId, colorId } = product;
            product.isLowStock = getLowStockLabelStatus({
              ...product,
              hasStyleRoomFlag
            });
            return (
              styleId &&
              colorId && (
                <MicrosoftAdsProduct
                  key={`${styleId}-${colorId}`}
                  product={{ ...product, index: i }}
                  numMicrosoftAds={products.length}
                  isInCarousel={true}
                  trackMicrosoftAdImpressions={trackMicrosoftAdImpressions}
                  makeMicrosoftAdClick={makeMicrosoftAdClick}
                  msaImageParams={msaMelodyImageParams}
                  CardBottomSlot={CardBottomSlot}
                  isFullMaxWidth={isFullMaxWidth}
                />
              )
            );
          })}
        </MelodyCarousel>
      </div>
    </div>
  );
};

export default MicrosoftAdsCarousel;
